<template>
    <!-- 個人中心 > 會員店家 -->
    <div>
        <navigation-bar Back Bell/>
        <div class="main container">

            <el-row type="flex" justify="space-between">
                <el-col :span="6">
                    <el-button class="edit" round v-if="showHidden">編輯</el-button>
                </el-col>
                <el-col :span="18" class="buttons">
                    <img class="filter" src="@/assets/images/filter.svg" alt="" v-if="showHidden">
                    <img class="calendar" src="@/assets/images/icon-date2.svg" alt="" v-if="showHidden">
                </el-col>
            </el-row>

            <div class="no-data" v-if="list.length===0">
                <img src="@/assets/images/empty.svg">
                <p>OH！目前空空的</p>
            </div>

            <div class="list-style" v-for="(item, index) in list" :key="index"
                     @click="$router.push({name: 'StoreInfo', query: {id: item.id}})">
                    <div class="mr-3">
                        <el-image :src="item.imgLogoUrl" fit="cover" class="pic2" v-if="item.imgLogoUrl !== ''"/>
                        <el-image :src="require('@/assets/images/default_image.svg')" fit="cover" class="pic2" v-else/>
                    </div>
                    <div class="content">
                        <h2>{{item.brandName}}<span class="ml-3">{{item.name}}</span></h2>
                        <div class="business-hours" @click.stop="item.showBusiness=!item.showBusiness">
                            <span class="status">{{item.businessHours.businessStatusString}}．</span>{{item.businessHours.endBusinessTimePeriodString}}
                            <i class="el-icon-caret-bottom" v-show="!item.showBusiness"></i>
                            <i class="el-icon-caret-top" v-show="item.showBusiness"></i>
                        </div>
                        <div class="business-hours" v-show="item.showBusiness">
                            <ul class="text-left">
                                <li class="week">星期一 <span
                                        v-html="showBusinessTime(item.businessHours.monday)"></span></li>
                                <li class="week">星期二 <span
                                        v-html="showBusinessTime(item.businessHours.tuesday)"></span></li>
                                <li class="week">星期三 <span
                                        v-html="showBusinessTime(item.businessHours.wednesday)"></span></li>
                                <li class="week">星期四 <span
                                        v-html="showBusinessTime(item.businessHours.thursday)"></span></li>
                                <li class="week">星期五 <span
                                        v-html="showBusinessTime(item.businessHours.friday)"></span></li>
                                <li class="week">星期六 <span
                                        v-html="showBusinessTime(item.businessHours.saturday)"></span></li>
                                <li class="week">星期日 <span
                                        v-html="showBusinessTime(item.businessHours.sunday)"></span></li>
                            </ul>
                        </div>
                        <!--todo 外送資訊-->
                        <div class="takeout-list single" @click.stop="isOpen(index)" v-if="false">
                            <div class="title">
                                <i class="el-icon-goods"/>外送：
                            </div>
                            <div class="con">
                                0-3km 滿$500 免運<br>
                                3km以上-4km $50<br>
                                5km以上-7km $100<br>
                            </div>
                            <div class="icon-arrow">
                                <i class="el-icon-caret-bottom"/>
                            </div>
                        </div>
                        <div class="icons">
                            <el-button
                                    v-if="item.tel !== ''"
                                    @click.stop="$public.callTel(item.tel)"
                                    type="text"
                                    class="store-phone-btn"/>
                            <el-button
                                    v-if="item.city !== ''"
                                    type="text"
                                    class="store-location-btn"
                                    @click.stop="onClickLocationBtn(item.lat, item.lng, item.googleMapUrl)"/>
                        </div>
                    </div>
                    <!--<el-col :span="20">
                      <ul class="store-info">
                        <li><a @click="$public.callTel(item.tel)"><span>{{item.tel}}</span></a></li>
                        <li @click="$public.openMap(item.lat, item.lng)">{{item.city+item.township+item.address}}</li>
                      </ul>
                    </el-col>-->
                    <tag-list :switchFlag="[false, item.onlineOrderStatus, item.bookingStatus, false, false]" @clickTag="onClickTag($event, item)"/>
                </div>

            <infinite-loading @infinite="setupDataScroll" spinner="waveDots" v-if="setupData">
                <div slot="no-more">沒有更多資料</div>
                <span slot="no-results"/>
            </infinite-loading>

            <loading
                    :active.sync=isLoading
                    :can-cancel="false"
                    :is-full-page="true"/>

        </div>
        <comm-dialog v-show="!isLogin" :value="!isLogin" :outerContent="'請先登入'" :isCancel="false" class="dialog-dark"
                     :isModal="false" @result="onCommDialogClose"></comm-dialog>
        <toast/>
    </div>
</template>

<script>
    import TagList from '@/components/TagList.vue';
    import CommDialog from '@/components/CommDialog.vue';
    import Toast from "@/components/Toast.vue";
    import * as mutationTypes from '@/store/mutationTypes';
    import {getCryptoUserInfo} from "@/util/cryptoLocalStorage";

    export default {
        name: "MemberStore",
        components: {
            TagList,
            CommDialog,
            Toast,
        },
        data() {
            return {
                isLoading: false,
                isLogin: this.$auth.isAdminLogin(true),
                storeInfo: undefined,           // 要執行動作的店家的資料
                bookingUrl: '',                 // 線上訂位網址
                encryptUrlSegment:'',           //預約訂位用的加密參數
                userId:'',
                list: [],

                pageSize: 10,
                currentPage: 0,

                dayList: ["sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday"],
                weekDay: new Date().getDay(),
                showHidden: false,
                setupData: false,
                lng: 0,
                lat: 0,
            }
        },
        created() {
        },
        mounted() {
            let self = this;
            //this.isLoading = true;
            let onSuccess = function (position) {
                self.lng = position.coords.longitude;
                self.lat = position.coords.latitude;
                //self.isLoading = false;
                self.setupData = true;
            };
            let onError = function (error) {
                self.lng = 0;
                self.lat = 0;
                //self.isLoading = false;
                self.setupData = true;
                self.$public.showNotify("code: " + error.code + ", message: " + error.message + "。無法定位GPS", false, 3000)
            };

            self.$public.getGpsLocation(onSuccess, onError);
        },
        methods: {
            setupDataScroll: function ($state) {
                //好友串門子
                let self = this;
                //this.isLoading = true;
                //
                this.$http.fetchWithAuth`AddStoreList${{
                    offset: this.currentPage,
                }} ${json => {
                    if (json.data.length >= this.pageSize) {
                        this.currentPage++;
                        this.list.push(...json.data);
                        $state.loaded();
                    } else {
                        this.currentPage++;
                        this.list.push(...json.data);
                        $state.complete();
                    }
                    //this.isLoading = false;
                }}`;
            },
            showBusinessTime: function (item) {
                if (item !== "休息日") {
                    let showTime = "";
                    item.forEach(function (value) {
                        showTime = showTime + value + '<br/>';
                    })
                    return showTime.slice(0, showTime.length - 5);
                } else {
                    return "休息日"
                }
            },

            /** tag 點擊事件 */
            onClickTag: function (result, storeItem) {

                if (this.isLogin) {
                    switch(result) {
                        case 'broadcast': //公告
                        {
                            this.$store.commit(mutationTypes.SHOW_TOAST, '此功能尚未開放');
                        }
                            break;
                        case 'order':   //點餐
                        {
                            this.$router.push({name: 'OrderList', query:{id: storeItem.id}});
                        }
                            break;
                        case 'booking': //訂位
                        {
                            let self = this;
                            this.callGetStoreInfoByIdApi(storeItem.id, self.lng, self.lat)
                                .then( () => {
                                    let encryptUrlSegment = self.combineBookingParams();
                                    self.loadBooking(encryptUrlSegment);
                                })
                                .catch( (error) => {
                                    self.isLoading = false;
                                    self.$store.commit(mutationTypes.SHOW_TOAST, error);
                                });
                        }
                            break;
                        case 'waiting': //候位
                        {
                            // this.$router.push({name: 'OrderList', query:{id: storeItem.id}});
                            this.$store.commit(mutationTypes.SHOW_TOAST, '此功能尚未開放');
                        }
                            break;
                        case 'comment': //評論
                        {
                            this.$store.commit(mutationTypes.SHOW_TOAST, '此功能尚未開放');
                        }
                            break;
                        default:
                        {
                            this.$store.commit(mutationTypes.SHOW_TOAST, '此功能尚未開放');
                        }
                            break;
                    }
                }

                // this.$router.push({name: 'OrderList', query:{id: this.storeInfo.id}});
            },

            /** CommDialog 關閉事件 */
            onCommDialogClose: function (result) {
                if (result) {
                    this.$router.push({name: 'Login'});
                }
            },

            isOpen(id) {//外送詳細開合
                document.getElementsByClassName('takeout-list')[id].classList.toggle("open")
            },

            /** 點擊地點按鈕 */
            onClickLocationBtn: function (lat = 0, lng = 0, googleMapUrl = null) {
                // console.log(`onClickLocationBtn lat: ${lat}, lng: ${lng}, googleMapUrl: ${googleMapUrl}`);
                if (this.$public.notNull(googleMapUrl) && googleMapUrl !== '') {
                    let param = this.$public.analyzeGoogleMapUrl(googleMapUrl);
                    // console.log(`param lat: ${param.googleMapLat}, lng: ${param.googleMapLng}, googleMapUrl: ${param.googleMapStoreInfoData}`);
                    if (this.$public.notNull(param)) {
                        //開啓地圖
                        if (this.$public.notNull(param.googleMapStoreInfoData) && param.googleMapLat > 0 && param.googleMapLng > 0) {
                            //爲避免店家輸入的url打開後效果不統一，一律先分析再從公用函式開啓頁面
                            this.$public.openMap(param.googleMapLat, param.googleMapLng, param.googleMapStoreInfoData);
                        } else {
                            this.$public.openMap(param.googleMapLat, param.googleMapLng);
                        }
                    }

                } else if (lat !== 0 && lng !== 0) {
                    this.$public.openMap(lat, lng);
                }
            },

            /** 呼叫 取得店家資訊api */
            callGetStoreInfoByIdApi (storeId, lng, lat) {

                let self = this;
                self.isLoading = true;

                //取得店家資訊
                return new Promise(function(resolve, reject) {
                    self.$http.fetch`GetStoreInfoById${{
                        id: storeId,
                        lng: lng,
                        lat: lat,
                    }} ${json => {
                        self.isLoading = false;

                        if (self.$public.notNull(json.data)) {
                            self.storeInfo = json.data;

                            resolve();
                            // console.log('storeImgAry:' + self.storeImgAry);
                        } else {
                            reject(`GetStoreInfoById: 無法取得資料`);
                        }
                    }}`;
                });
            },

            /** 產生訂候位用的參數 */
            combineBookingParams : function() {
                let self = this;
                let usertoken = localStorage.getItem("admin_token");
                if (self.$public.notNull(usertoken) && usertoken !== '') {
                    let decrypted = self.$crypto.decryptText(usertoken);
                    let decrypted_array = decrypted.split(';');

                    // const userData = JSON.parse(localStorage.getItem('userInfo') || "");
                    const userData = getCryptoUserInfo();
                    if (self.$public.notNull(userData)) {
                        let user_name = userData.name;
                        let phone = userData.phone;
                        let gender = userData.gender;
                        let email = userData.email;

                        let encryptString = user_name + ";" + phone + ";" + gender + ";" + email + ";" + decrypted_array[0];
                        let encryptedString = self.$crypto.encryptText(encryptString);
                        let secondEncrypt = encodeURIComponent(encryptedString);
                        let encryptUrlSegment = secondEncrypt;
                        return encryptUrlSegment;
                    }
                }
                // console.log('storeImgAry:' + self.storeImgAry);
                return '';
            },

            /** 開啓訂位網頁 */
            loadBooking : function(encryptUrlSegment){
                let urlSet = this.storeInfo.bookingUrl + "/" + encryptUrlSegment;

                let self = this;
                let browser = this.$public.isCordova()? (this.$public.notNull(window.cordova?.InAppBrowser)?window.cordova.InAppBrowser: window): window;
                //使用 _system的話會呼叫 app外部的 browser來開網頁
                let appInBrowser = browser.open(urlSet, '_blank', 'toolbar=no,location=no' + self.$http.browserOpenFeatures());

                // 注意，這一段是針對使用 InAppBrowser這個套件專用的方法
                //如果是 cordova開啓，就植入 javascript持續取得網頁網址 location.href，
                //直到轉成訂位成功的頁面，再將另一段 javascript植入加入行事曆按鈕中，發射 message給 app接收
                if (this.$public.isCordova()) {

                    if (this.$public.notNull(appInBrowser)) {
                        let loop = null;

                        appInBrowser.addEventListener('message', function(...args) {

                            if (self.$public.notNull(args) && self.$public.notNull(args[0])) {
                                let msgObj = args[0];
                                if (msgObj.type === 'message') {
                                    if (self.$public.notNull(msgObj.data) &&
                                        self.$public.notNull(msgObj.data.message)){

                                        if (msgObj.data.message.indexOf('booking-confirm') >= 0) {
                                            // console.log(`#### #### add calendar message = ${JSON.stringify(msgObj.data.message)}`);
                                            //加入到行事曆
                                            if (self.$public.notNull(self.storeInfo)) {
                                                self.onBookingCompleted(msgObj.data.message, self.storeInfo.brandName);
                                            }
                                            appInBrowser.close();

                                        } else if (msgObj.data.message.indexOf('close') >= 0) {
                                            appInBrowser.close();
                                        }
                                    }
                                }
                            }
                        }, false);

                        //監聽 '載入完成' 事件
                        appInBrowser.addEventListener('loadstop', function(event) {
                            //取得訂位網頁左上角的'關閉'按鈕，並植入關閉的方式
                            appInBrowser.executeScript({
                                code: "document.getElementById('closeBtn').addEventListener(\"click\",function(e){" +
                                    "const message = {message: 'close'};" +
                                    "webkit.messageHandlers.cordova_iab.postMessage(JSON.stringify(message));" +
                                    "},false);"
                            });

                            //setInterval，會一直取得網頁位址，直到位址內有 booking-confirm才會停止
                            loop = setInterval(function() {

                                appInBrowser.executeScript(
                                    {
                                        //此寫法表示，把 location.href傳給 function( values )，注意 values爲陣列
                                        code: "location.href;"
                                    },
                                    function( values ) {

                                        //植入另一段 javascript
                                        if (self.$public.notNull(values) && self.$public.notNull(values[0]) &&
                                            values[0].indexOf('booking-confirm') >= 0) {

                                            //停止迴圈
                                            clearInterval( loop );

                                            //尋找 id爲 addCalender的元件(前端要先寫好)，植入按下按鈕要觸發的動作
                                            //按下後會傳回目前網頁位址，以 message的形式發送給 inAppBrowser套件
                                            appInBrowser.executeScript({
                                                code:
                                                    "document.getElementById('addCalender').addEventListener(\"click\",function(e){" +
                                                    "const messageObj = { message: location.href};" +
                                                    "webkit.messageHandlers.cordova_iab.postMessage(JSON.stringify(messageObj));" +
                                                    "}, false);"+
                                                    "document.getElementById('closeBtn').addEventListener(\"click\",function(e){" +
                                                    "const message = {message: 'close'};" +
                                                    "webkit.messageHandlers.cordova_iab.postMessage(JSON.stringify({message}));" +
                                                    "},false);"
                                            });
                                        }
                                    }
                                );
                            }, 1000);

                        }, true);
                    }
                }

                // self.onBookingCompleted('https://booking-test.oinapp.com/app/39/booking-confirm?id=OKZRa5Hhec1J8j4kpptQLJpnWX4%3D&store=健康旗艦店&date=2021-11-28&time=18%3A00&result=success');
            },

            /** 訂位完成時 */
            onBookingCompleted: function (params, brandName) {
                //訂位完成後會跳到 http://xxx.xxx:8082/app/booking-confirm?id=paFW43Obqq%2BNmahwWtXCWTDyH0A%3D&store=Gottone%20%E8%94%AC%E9%A3%9F&date=2021-11-17&time=12%3A30&result=success
                let success = false;
                let date = '', storeName = '';
                let year = 0, month = 0, day = 0, hour = 0, minute = 0;


                if (this.$public.notNull(params) && params.indexOf('booking-confirm') >= 0) {
                    let decodeUrl = decodeURIComponent(params);
                    // console.log(`#### decodeUrl: ${decodeUrl}`);
                    decodeUrl.split('&').forEach(
                        //解析網址
                        element => {
                            if (element.indexOf('result=') >= 0) {
                                success = element.indexOf('success') >= 0;

                            } else if (element.indexOf('date=') >= 0) {
                                date = element.substr(element.indexOf('date=')+5);

                                let bookingDate = new Date(date);
                                year = bookingDate.getFullYear();
                                month = bookingDate.getMonth();
                                day = bookingDate.getDate();

                            } else if (element.indexOf('time=') >= 0) {
                                let time = element.substr(element.indexOf('time=')+5);
                                let timeSplit = time.split(':');
                                if (this.$public.notNull(timeSplit)) {
                                    hour = Number(timeSplit[0]);
                                    minute = Number(timeSplit[1]);
                                }

                            } else if (element.indexOf('store=') >= 0) {
                                storeName = element.substr(element.indexOf('store=')+6);
                            }
                        }
                    )
                }

                if (success) {
                    //加入行事曆
                    this.$public.addCalendarEvent(this.$http.getOS(), `${brandName} ${storeName} 訂位`, year, month, day, hour, minute);

                } else {
                    alert("無法將訂位行程加入行事曆");
                }

                // console.log(`onBookingCompleted ! ${params}`);
            },

        }
    }
</script>

<style lang="less" scoped>
    .edit {
        background: #F0D870;
        color: #fff;
        border: 0px;
        padding: 8px 14px
    }
    .buttons {
        display: flex;
        justify-content: flex-end
    }
    .filter {
        width: 80px;
        margin-right: 20px
    }
    .calendar {
        width: 25px;
    }
    .business-hours {
        font-size: 13px;
        color: #5F5E5E;
        .status {
            color: #E37E84;
        }
        .week {
            display: flex;
            span {
                margin-left: 8px;
            }
        }
    }

</style>